import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ActionService } from '../../modules/shared/services/action.service';
import { map } from 'rxjs/operators';
import { journalUpdate } from './journal.actions';
import { messengerActionUpdate } from '../messenger/messenger.actions';

@Injectable()
export class JournalEffects {

    constructor(private actions$: Actions) {
    }

    journalUpdate$ = createEffect(() => this.actions$.pipe(
        ofType(messengerActionUpdate),
        map((action) => journalUpdate({ action: action.action }))
    ));
}
